var brandInfoAll={
  bannerInfo:{
    bannerNmae:"贝托",
    createTime:"2018年",
    area:"中国 浙江",
    honor:[
      'CE认证',
      // '天津市技术领先型企业',
      // '天津市瞪羚企业'
    ],
  },
  subsidiary:[
    {
      name:"平湖",
      langname:"贝托（总公司）",
      address:"浙江省嘉兴市平湖市钟埭街道兴平一路508号5幢",
      corporateName:"浙江贝托传动科技有限公司"
    },
    {
      name:"山东",
      langname:"贝托（分公司）",
      address:"山东省济南市天桥区堤口路88号",
      corporateName:"贝托传动设备(山东)有限公司"
    },
    {
      name:"上海",
      langname:"贝托（分公司）",
      address:"上海市嘉定区新成路500号J2458室",
      corporateName:"上海钡托传动科技有限公司"
    },
    {
      name:"深圳",
      langname:"贝托（分公司）",
      address:"深圳市宝安区燕罗街道山门社区松岗大道72号4M",
      corporateName:"深圳市贝拓传动设备有限公司"
    },
    {
      name:"江苏",
      langname:"贝托（分公司）",
      address:"无锡惠山经济开发区堰新路311号3号楼",
      corporateName:"江苏钡托传动科技有限公司"
    },
  ],
  advantages:{
    advantages:"/static/brand/zhitong/youshi/left.png",
    advantagesTitle:"/static/brand/zhitong/youshi/top.png",
    info:"产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。",
    type:1
  },
  certify:[
     
  ],
  pindustry:{
      industryTitleImg:"/static/brand/qingneng/hangye/industryTitleImg.png",
      list:[
        {
          bjimg:"/static/brand/beituo/hangye/1.jpg",
          title:"汽车制造",
        },
        {
          bjimg:"/static/brand/beituo/hangye/2.jpg",
          title:"机器人",
        },
        {
          bjimg:"/static/brand/beituo/hangye/3.jpg",
          title:"仓储物流",
        },
        {
          bjimg:"/static/brand/beituo/hangye/4.jpg",
          title:"工业自动化",
        },
        {
          bjimg:"/static/brand/beituo/hangye/5.jpg",
          title:"卫星通讯",
        },
        {
          bjimg:"/static/brand/beituo/hangye/6.jpg",
          title:"医疗器械",
        },
      ]    
    },
  bigimg:"/static/brand/zhitong/bigimg/big.png",

  otherProductsAdvantages:{
    productsTitle:"/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth:"849px",
    height:"214px",
    textTitle:"",
    textList:[
      '产品主要传动结构为行星轮，太阳轮，内齿圈。',
      '相对其他减速机，精密行星减速机具有高刚性、高精度、高传动效率、高的扭矩、体积比、终身免维护等特点。',
      '多数是安装在步进电机和伺服电机上，用来降低转速，提升扭矩，匹配惯量。',
      '广泛用于精密机械制造设备，数控设备，军工系统等。'
    ],
    textImg:"/static/brand/beituo/product.png",
    list:[
      {
        titleImg:"/static/brand/beituo/1.png",
        infoList:[
          '电机通用性',
        ],
        title:"连接法兰、轴套方式"
      },
      {
        titleImg:"/static/brand/beituo/2.png",
        infoList:[
          '使用高粘度、不易分离的润滑脂，有效防止润滑脂泄露',
        ],
        title:"高粘度润滑脂" 
      },
      {
        titleImg:"/static/brand/beituo/3.png",
        infoList:[
          '在产品寿命期内无需更换润滑脂，安装更便捷',
        ],
        title:"维护方便" 
      },
      {
        titleImg:"/static/brand/beituo/4.png",
        infoList:[
          '使用斜齿轮实现顺畅安静的运转',
        ],
        title:"静音" 
      },
      {
        titleImg:"/static/brand/beituo/5.png",
        infoList:[
          '齿隙低于3分、定位精确',
        ],
        title:"高精度" 
      },
      {
        titleImg:"/static/brand/beituo/6.png",
        infoList:[
          '使用整体式滚珠轴承，大大提高了刚性和扭矩',
        ],
        title:"高刚性、高扭矩"
      }
    ]
  },
  aboutus:
  {
        info:"浙江贝托传动科技有限公司成立于2018年。公司主要从事BEITTO贝托高精度行星减速机的研发，生产，为客户提供优质的产品服务。公司始终坚持日本机电尖端研发技术，坚承着日本细致考究的生产工艺，与日本多家研究室达成战略合作伙伴关系。精益求精的品质苛求，世界一流的创新技术，成就了贝托在机电行业的领导者地位，贝托立足中国辐射全球，产品覆盖中国市场全区域，并远销东南亚各地，赢得市场一直好评。贝托成为企业节能减排产业升级的得力助手！贝托自始至终重视现有产品的质量和行业所需求新产品的研发，引进国际业界多名顶尖技术工程师加盟，促使贝托能够一直致力于世界自动化产业的发展，为推动科技智能化社会的进步而不懈努力，坚持‘加贝努力，不负重托，追求卓越，引领创新’的企业精神，打造纯正日本技术的传动装置专业制造商。",
        poster:"/static/brand/beituo/video.png",
        aboutTitle:"/static/brand/beituo/top.png",
        aboutTitleWidth:"355px"
  },
  
  metaInfo:{
    title:"贝托传动_Movibot品牌_行星减速机",
    keywords:"行星减速机_高精度行星减速机_日本机电尖端研发技术_工业机器人_贝托传动",
    description:"贝托传动科技主要从事BEITTO贝托高精度行星减速机的研发，生产和服务。MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。",
  }
  


}
export default {
  brandInfoAll
};


// WEBPACK FOOTER //
// ./src/data/brand/11.js